<style>
</style>

<template>

  <div class="form-group">

    <div class="form-group--three-columns acceptables-grid">
      <div v-if="acceptablesSetting.length >= 1" v-for="(item, index) in acceptablesSetting" class="form-row">
        <el-form-item class="item-checkbox">
          <el-checkbox v-model="item.enabled" 
          :checked="item.prohibited" 
          @change="updateSettings()" 
          :disabled="!overridden || readOnly">
          {{ parseFloat(item.denomination.value).toFixed(2) }}
          </el-checkbox>
        </el-form-item>
      </div>
    </div>

  </div>

</template>

<script>

  export default {
    name: 'DqAcceptablespanel',
    replace: true,
    props: {
      label: '',
      overridden: false,
      acceptablesSetting: [],
      readOnly: false
    },
    data: function () {
      return {
        acceptablesSettingNew: [...this.acceptablesSetting]
      }
    },
    mounted () {
      this.updateSettings()
    },
    watch: {
      acceptablesSettings: function () {
        this.updateSettings()
      }
    },
    methods: {
      updateSettings () {
        this.acceptablesSettingNew = [...this.acceptablesSetting]
        this.$store.commit('overrideAcceptablesSetting/setOverrideAcceptablesSetting', { acceptablesSetting: this.acceptablesSettingNew })
      }
    }
  }
</script>

<style lang="scss">
.acceptables-grid {
  column-count: 3;
  column-gap: 50px;

  .form-row {
    break-inside: avoid;
    -webkit-column-break-inside: avoid;
    page-break-inside: avoid;
    display: inline-block;
    width: 100%;
  }
}

@media (max-width: 1200px) {
  .acceptables-grid {
    column-count: 2;
  }
}

@media (max-width: 768px) {
  .acceptables-grid {
    column-count: 1;
  }
}
</style>



// WEBPACK FOOTER //
// acceptablespanel.vue?776b5f56